import Vue from 'vue';
const paginationCom = r => require.ensure([], () => r(require('./pagination/pagination.vue')), 'paginationCom');
const components={
    install(Vue){
		  Vue.component('paginationCom',paginationCom)
    }
}
//判断
if(typeof window !=='undefined' && window.Vue){
	install(window.Vue);
}

export default components;
